import { render, staticRenderFns } from "./PhotoGallery.vue?vue&type=template&id=2da80ded&scoped=true"
import script from "./PhotoGallery.vue?vue&type=script&lang=js"
export * from "./PhotoGallery.vue?vue&type=script&lang=js"
import style0 from "./PhotoGallery.vue?vue&type=style&index=0&id=2da80ded&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2da80ded",
  null
  
)

export default component.exports